import { StyleSheet } from 'react-native';
import {
  fontFamilyLight,
  fontSizeMediumLarge,
} from '../../../constants/palette';

export default StyleSheet.create({
  container: {
    marginBottom: 2.5,
    marginTop: 2.5,
  },
  text: {
    fontFamily: fontFamilyLight,
    fontSize: fontSizeMediumLarge,
  },
});
